$.fn.Vh = function() {
  let self = this

  self.update = function() {
    self.css('--vh', window.innerHeight + 'px');
  }

  return function() {
    $(window).on('load orientationchange resize', self.update)
    return self
  }()
}

export default {
  init() {
    $('body').each(function() {
      $(this).Vh()
    })
  },
}
